module.exports = __webpack_public_path__ + "img/upper ruffle length.5ddd8aa6.png";